import React, { useState } from 'react';

import { Wrench, Package } from 'lucide-react';
import CalibrationMainPage from '../../components/Calibration/CalibrationMainPage';
import MaterialsMainPage from '../../components/Materials/MaterialsMainPage';
import '../technical/HeatProfilePage.css';
import './CalibrationPage.css';

const TAB_ITEMS = [
    { id: 'calibration', label: 'Calibration', icon: <Wrench size={18} /> },
    { id: 'materials', label: 'Materials', icon: <Package size={18} /> },
];

const Tabs = ({ items, activeTabId, onTabClick }) => {
    return (
        <div className="calibration-tabs-container">
            <div className="calibration-tabs">
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={`calibration-tab-item ${activeTabId === item.id ? 'active' : ''}`}
                        onClick={() => onTabClick(item.id)}
                    >
                        {item.icon}
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

const CalibrationPage = () => {
    const [activeTab, setActiveTab] = useState('calibration');

    return (
        <div className="calibration-page">

            <Tabs
                items={TAB_ITEMS}
                activeTabId={activeTab}
                onTabClick={setActiveTab}
            />



            <div className="calibration-content-wrapper heat-profile-content-wrapper">
                {activeTab === 'calibration' ? (
                    <CalibrationMainPage embeddedInModernLayout />
                ) : (
                    <MaterialsMainPage embeddedInModernLayout />
                )}
            </div>
        </div>
    );
};

export default CalibrationPage;
